<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领人</span>
              <a-button block style="text-align: left">
                {{ user.userName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领部门</span>
              <a-button block style="text-align: left">
                {{ department.deptUniqueName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              label="处置说明"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-textarea
                :auto-size="{ minRows: 3 }"
                v-decorator="[
                  'remarks',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="between">
          <div class="title">固定资产处置清单</div>
          <AssetHandleSelector @change="addMaterial">
            <a-button
              type="primary"
              style="background: #ff8c18; border: 1px solid #ff8c18"
              icon="plus"
            >
              添加
            </a-button>
          </AssetHandleSelector>
        </div>
        <a-table bordered :dataSource="list" :pagination="false">
          <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
          <a-table-column title="资产类别">
            <template slot-scope="text">
              <div style="display: flex; align-items: center">
                <DataDictFinder
                  dictType="fixed_asset_type"
                  :dictValue="text.category.categoryCode"
                />-
                {{ text.category.subCategoryName }}
              </div>
            </template>
          </a-table-column>
          <a-table-column title="品牌型号" data-index="brandModel"> </a-table-column>
          <a-table-column title="财务编码" data-index="financialCode"> </a-table-column>
          <a-table-column title="启用日期" data-index="startTime"> </a-table-column>
          <a-table-column title="原值" data-index="purchasePrice"> </a-table-column>
          <a-table-column title="净残值率" data-index="netSalvageRate"></a-table-column>
          <a-table-column title="残值" data-index="netAmount"></a-table-column>
          <a-table-column title="操作" align="center" width="100px">
            <template slot-scope="text, record, index">
              <a href="#" class="danger" @click.prevent="remove(index)"> 移除 </a>
            </template>
          </a-table-column>
        </a-table>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary" :loading="loading">
              {{ id ? "重新提交" : "保存" }}
            </a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
import { mapState, mapGetters } from "vuex";
import EmployeeSelector from "@/components/employee-selector";
import AssetHandleSelector from "./components/assetHandleSelector";
function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset-category/list",
    data,
    method: "post",
  });
}
function fetchApplyDetail(id) {
  return request({
    url: "/office-service/fixed-asset/scrap/" + id,
    method: "post",
  });
}
function apply(data) {
  return request({
    url: "/office-service/fixed-asset/scrap",
    data,
    method: "post",
  });
}
function reapply(data) {
  return request({
    url: "/office-service/fixed-asset/reScrap",
    data,
    method: "post",
  });
}
export default {
  data() {
    return {
      index: 0,
      assetsCategoryList: [],
      selectedUser: {},
      form: this.$form.createForm(this),

      list: [],

      loading: false,

      id: null, // 已发起申领申请的 id
    };
  },
  components: {
    EmployeeSelector,
    AssetHandleSelector
  },
  mounted() {
    const { query } = this.$route;
    const { id } = query || {};

    if (id) {
      // 重新提交
      this.id = id;
      fetchApplyDetail(id).then((res) => {
        console.log("result", res);
        if (res) {
          this.form.setFieldsValue({
            remarks: res.description,
          });

          this.list = Array.isArray(res.fixedAssetList)
            ? res.fixedAssetList: [];
        }
      });
    }

    fetchList({
      pageNum: 1,
      pageSize: 10000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.assetsCategoryList = res.list;
      }
    });
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),

    ...mapGetters("setting", ["findDataDict"]),

    typeList() {
      return this.findDataDict("giftType");
    },
  },

  methods: {
    showEmployeeSelector(index) {
      this.index = index;
    },
    addMaterial(value) {
      this.list = this.list.concat(value);
      //去掉重复id的数据
      this.list = this.list.filter((item, index, arr) => {
        return arr.findIndex((item2) => item2.id === item.id) === index;
      });
    },
    renderSubType(type, subType) {
      const obj = this.typeList.find((item) => item.value === type);
      if (obj && Array.isArray(obj.children)) {
        const subTypeObj = obj.children.find((item) => item.value === subType);
        if (subTypeObj) {
          return subTypeObj.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    // 用户选择了品名和数量
    add(payload) {
      const index = this.list.findIndex((item) => item.id === payload.id);
      if (index === -1) {
        this.list.push(payload);
      } else {
        this.list.splice(index, 1, payload);
      }
    },

    remove(index) {
      this.list.splice(index, 1);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.list.length === 0) {
            this.$message.error("请添加固定资产");
            return;
          }

          this.loading = true;
          const { remarks } = values;

          if (this.id) {
            reapply({
              id: this.id ? this.id : undefined,

              applicantId: this.user.uuid,
              applicant: this.user.userName,
              // 申领部门
              applicantDeptId: this.department.deptId,
              applicantDeptName: this.department.deptUniqueName,
              description: remarks,

              fixedAssetList: this.list
            })
              .then(() => {
                this.$close(this.$route.path);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            apply({
              // 申领人
              applicantId: this.user.uuid,
              applicant: this.user.userName,
              // 申领部门
              applicantDeptId: this.department.deptId,
              applicantDeptName: this.department.deptUniqueName,
              description: remarks,

              fixedAssetList: this.list
            })
              .then(() => {
                this.list = [];
                this.form.resetFields();
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}

.center {
  margin-top: 80px;
}
</style>
